import styled from "styled-components";

export const Brand = styled.div`
  background-color: ${(props) => props.color || "#563d7c"};
  width: 1.7rem;
  height: 1.7rem;
  border-radius: 6px;
`;
